import axios from "axios";

//const BASE_URL = process.env.VUE_APP_DEMANDAS_REPETITIVAS_URL;
const PROD = 'production'
const BASE_URL = process.env.NODE_ENV === PROD ? '/' : process.env.BASE_URL
const PORTAL_URL = process.env.VUE_APP_PORTAL_URL || 'https://www.tjpa.jus.br/PortalExterno/'

const appUrl = (r) => `${BASE_URL}api/demandasrepetitivas/${r}`

export { appUrl, PORTAL_URL }

const ParametrosDeBuscaTema = {
  numProcessoPJe: "",
  numeroUnicoTema: "",
  situacao: 0,
  numeroProcesso: "",
  page: null,
  itensporpagina: 10
}

const Tema = {
  numeroUnicoTema: "",
  codigo: "",
  relator: "",
  idRamoDireito: 0,
  situacao: 0,
  idTipoTema: 0,
  questao: "",
  tese: "",
  referenciaLegislativa: "",

  dataEmbargos: "",
  dataAdmissao: "",
  
  processosParadigmas: [],
  assuntoTema: []
}

const ProcessoParadigma = {
  numProcessoPJe: "",
  orgaoJulgador: "",
  dataAcordao: "",
  dataTransito: "",
  classe: "",
  dataJulgamento: ""
}

const AssuntoTema = {
  id: 0,
  codigo: 0,
  descricao: "",
  idTema: 0,
  in_ativo: ""
}

const RamoDireito = {
  id: 0,
  descricao: "",
  ativo: ""
}
const SituacaoTema = {
  id: 0,
  descricao: "",
  ativo: ""
}
const TipoTema = {
  id: 0,
  descricao: "",
  ativo: ""
}

export { ParametrosDeBuscaTema, Tema, ProcessoParadigma, AssuntoTema, RamoDireito, SituacaoTema, TipoTema }


const fetch = (method, url, data) => axios({ method, url, data });
const baseUrlGet = (url, params) => fetch("get", appUrl(url), params);
const baseUrlDelete = url => fetch("delete", appUrl(url));
const postDataToUrl = (data, url) => axios({ method: "post", url, data });
const putDataToUrl = (data, url) => axios({ method: "put", url, data });
const baseUrlPostDataToUrl = (data, url) => postDataToUrl(data, appUrl(url));
const baseUrlPutDataToUrl = (data, url) => putDataToUrl(data, appUrl(url));
const DELETE_SUCCESS = "Exclusão de tema realizada com sucesso!";
const DELETE_FAILURE = "Falha na realização da exclusão!";
const CREATE_SUCCESS = "foi cadastrado com sucesso!"
const CREATE_FAILURE = "Falha na criação do novo tema!";
const ALTER_SUCCESS = "foi atualizado com sucesso!"
const ALTER_FAILURE = "Falha na alteração do tema!";

export { fetch, baseUrlGet, baseUrlDelete, postDataToUrl, baseUrlPostDataToUrl }
export { DELETE_FAILURE, DELETE_SUCCESS, CREATE_SUCCESS, CREATE_FAILURE, ALTER_SUCCESS, ALTER_FAILURE }


/* const mapping = a => a.map(s => ({ label: s.descricao, value: s.id })); */
const copyArray = (a, b) => a.splice(0, a.length, ...b);

const _fetchAllSituacao = async () => ((await baseUrlGet("situacaotema")).data["listaDeSituacoesTema"])
const fetchAllSituacao = async (callback) => callback(await _fetchAllSituacao())

const _fetchAllRamos = async () => ((await baseUrlGet(`ramodireito`)).data["listaDeRamosDireito"])
const fetchAllRamos = async (callback) => callback(await _fetchAllRamos())


const _fetchAllTipos = async () => ((await baseUrlGet(`tipotema`)).data["listaDeTiposTema"])
const fetchAllTipos = async (callback) => callback(await _fetchAllTipos())

const saveTema = (tema) => baseUrlPostDataToUrl(tema, 'tema')
const updateTema = (tema) => baseUrlPutDataToUrl(tema, 'tema')
const fetchTema = async (id, callback) => callback((await baseUrlGet(`tema/${id}`)).data["tema"])

export {
  saveTema,
  updateTema,
  copyArray,
  fetchTema,
  fetchAllSituacao,
  fetchAllRamos,
  fetchAllTipos
}


const FETCH_ALL = `tema?page=0&itensporpagina=0`
const _fetchTemasLength = async () => (await baseUrlGet(FETCH_ALL)).data["meta"]["totalTemas"]
const fetchTemasLength = async (cb) => (cb(await _fetchTemasLength()))

const TEMAS_URL_PAGE_PERPAGE = (page, rowsPerPage) => `tema?page=${--page}&itensporpagina=${rowsPerPage}`
const DEFAULT_PAGINATION = { rowsPerPage: 10 }
const _fetchTemasPage = async (page = 1, pagination = DEFAULT_PAGINATION) =>
  (await baseUrlGet(TEMAS_URL_PAGE_PERPAGE(page, pagination.rowsPerPage))).data["listaDeTemas"]
const fetchTemasPage = async (page, pagination, callback) => callback(_fetchTemasPage(page, pagination))

const filterFunction = (_filtered, _list, val, update) => {
  const copyArray = (a, b) => a.splice(0, a.length, ...b);
  const showAll = () => copyArray(_filtered, _list);
  const filter = () => {
    const needle = val.toLowerCase();
    const containsVal = v => v.descricao.toLowerCase().indexOf(needle) > -1;
    copyArray(_filtered, _list.filter(containsVal));
  };
  const emptyVal = val === "";
  update(emptyVal ? showAll : filter);
};

export { fetchTemasLength, fetchTemasPage, filterFunction }

const fetchRamoDireito = async (id, callback) => callback((await baseUrlGet(`ramodireito/${id}`)).data["ramoDireito"])
const fetchSituacaoTema = async (id, callback) => callback((await baseUrlGet(`situacaotema/${id}`)).data["situacaoTema"])
const fetchTipoTema = async (id, callback) => callback((await baseUrlGet(`tipotema/${id}`)).data["tipoTema"])

export { fetchRamoDireito, fetchSituacaoTema, fetchTipoTema }
